import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AdminRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return null;
  if (!currentUser || !currentUser.isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
